var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "elSelect",
      staticClass: "Weforsys-selectTree",
      attrs: {
        filterable: "",
        value: _vm.valueTitle,
        clearable: _vm.clearable,
        disabled: _vm.disabled,
        placeholder: _vm.placeholder,
        "popper-class": "Weforsys-select-tree " + _vm.themeClass,
        filterable: _vm.filterable,
        "filter-method": _vm.selectFilter,
      },
      on: { clear: _vm.clearHandle, focus: _vm.selectFocus },
    },
    [
      _c(
        "el-option",
        {
          staticClass: "options",
          attrs: { value: _vm.valueTitle, label: _vm.valueTitle },
        },
        [
          _c("el-tree", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.options.length,
                expression: "options.length",
              },
            ],
            ref: "selectTree",
            class: { single: !_vm.multiple },
            attrs: {
              id: "tree-option",
              accordion: _vm.accordion,
              data: _vm.options,
              "default-expand-all": _vm.defaultExpandAll,
              props: _vm.props,
              "node-key": _vm.props.value,
              "default-expanded-keys": _vm.defaultExpandedKey,
              "filter-node-method": _vm.filterNode,
              "show-checkbox": _vm.multiple,
              "check-on-click-node": _vm.multiple,
              "expand-on-click-node": !_vm.multiple,
            },
            on: { "node-click": _vm.handleNodeClick, check: _vm.check },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var node = ref.node
                    var data = ref.data
                    return _c(
                      "span",
                      { staticClass: "custom-tree-node" },
                      [
                        _vm._t(
                          "default",
                          [
                            data.icon
                              ? _c("i", { class: data.icon })
                              : _vm._e(),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(_vm._s(node.label)),
                            ]),
                          ],
                          { data: { node: node, data: data } }
                        ),
                      ],
                      2
                    )
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.options.length,
                  expression: "!options.length",
                },
              ],
              staticClass: "empty-text",
            },
            [_vm._v("无数据")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }